// src/features/documents/components/ColumnSettings.tsx
import { Settings, ArrowUp, ArrowDown } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Checkbox } from '@/components/ui/checkbox';
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@/components/ui/popover';
import type { ColumnDef, ColumnId } from '../types';

interface ColumnSettingsProps {
  columns: ColumnDef[];
  hidden: Set<ColumnId>;
  onToggle: (id: ColumnId) => void;
  onMove: (id: ColumnId, dir: -1 | 1) => void;
}

export function ColumnSettings({ columns, hidden, onToggle, onMove }: ColumnSettingsProps) {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button variant="outline" size="sm" className="gap-1.5">
          <Settings className="h-3.5 w-3.5" />
          Columns
        </Button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-56 p-0">
        <div className="px-3 py-2 text-xs font-semibold text-muted-foreground border-b">
          Columns
        </div>
        <div className="py-1">
          {columns.map((col, i) => (
            <div key={col.id} className="flex items-center gap-2 px-3 py-1">
              <Checkbox
                id={`col-${col.id}`}
                checked={!hidden.has(col.id)}
                onCheckedChange={() => onToggle(col.id)}
              />
              <label htmlFor={`col-${col.id}`} className="flex-1 text-sm cursor-pointer">
                {col.label}
              </label>
              <button
                type="button"
                disabled={i === 0}
                onClick={() => onMove(col.id, -1)}
                className="p-0.5 text-muted-foreground hover:text-foreground disabled:opacity-30"
              >
                <ArrowUp className="h-3 w-3" />
              </button>
              <button
                type="button"
                disabled={i === columns.length - 1}
                onClick={() => onMove(col.id, 1)}
                className="p-0.5 text-muted-foreground hover:text-foreground disabled:opacity-30"
              >
                <ArrowDown className="h-3 w-3" />
              </button>
            </div>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
}
